<template>
  <v-app>
    <v-main class="main-content">
      <!-- Decorative background shapes - fixed to viewport -->
      <div class="bg-shapes-container">
        <div class="bg-shape bg-shape-1"></div>
        <div class="bg-shape bg-shape-2"></div>
        <div class="bg-shape bg-shape-3"></div>
      </div>

      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Auth from '@/services/auth.service.js'

export default {
  mounted() {
    setInterval(() => {
      let auth = Auth.checkAuth();
      if (!auth) {
        this.$router.replace({ name: "login" })
      }
    }, 2 * 60 * 1000);
  },
}
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}

::-webkit-scrollbar-thumb {
  background-color: #0d2b6da8;
  border-radius: 3px;
}

.main-content {
  background: #f0f4f8;
  min-height: 100vh;
}

.bg-shapes-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.04;
}

.bg-shape-1 {
  width: 500px;
  height: 500px;
  background: #2196F3;
  top: -150px;
  right: -100px;
}

.bg-shape-2 {
  width: 350px;
  height: 350px;
  background: #4CAF50;
  bottom: -80px;
  left: -80px;
}

.bg-shape-3 {
  width: 250px;
  height: 250px;
  background: #FF9800;
  top: 40%;
  left: 5%;
}

/* Make sure router-view content stays above the shapes */
.main-content>.v-main__wrap {
  position: relative;
  z-index: 1;
  background: #f0f4f8;
}
</style>